module.exports = __webpack_public_path__ + "icon.warning.bd401cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon.warning.png
// module id = 859
// module chunks = 0